import React from 'react';
import {CaretDown16, FileDocument24} from "@hig/icons";
import Flyout, {anchorPoints} from "@hig/flyout";
// import docIa from '../../utils/doc-ia';

import './breadcrumbs.css';

const BreadCrumbs = () => {
    const docIa = window.docIa;
    const pathnameArr = window.location.pathname.split("/");
    const lastChild = (pathnameArr[pathnameArr.length - 1]) ? pathnameArr.length - 1 : pathnameArr.length - 2;

    if(!docIa || !docIa.url_path) {
        return (<div className="breadcrumb-container"></div>);
    }

    let breadCrumbArr = [
        {
            name: 'Documentation',
            url: '/developer/documentation'
        },
        {
            name: docIa.api_name,
            url: `/en/docs/${docIa.url_path}/${docIa.doc_version}`
        }
    ];

    let url = `/en/docs/${docIa.url_path}/${docIa.doc_version}`;
    let url_secondary = window.location.pathname.split(url + '/');
    url_secondary = url_secondary.length > 1 ? url_secondary[1] : [];

    if (url_secondary.length) {
        url_secondary = url_secondary.split('/')[0];
        let secondary = (docIa.children.filter(({url_path}) => url_path === url_secondary));
        if (secondary.length) {
            breadCrumbArr.push({
                name: secondary[0].display_name,
                url: `${url}/${secondary[0].url_path}`
            });
        }
    }

    return (
        <div className="breadcrumb-container">
            {breadCrumbArr.map(({name, url}, i) => {
                if (i < breadCrumbArr.length - 1) {
                    return <div key={i} className="breadcrumb">
                        <a 
                        data-test-id="documentation-breadcrumb-link"
                        data-external-target="documentation-breadcrumb-link"
                        className="breadcrumb-url" 
                        href={url}
                        >
                            {name}
                        </a>
                        <span className="breadcrumb-separator"> / </span>
                    </div>;
                }
                else {
                    return <div key={i} className="breadcrumb">
                        <a
                        data-test-id="documentation-breadcrumb-link"
                        data-external-target="documentation-breadcrumb-link" 
                        className="breadcrumb-url" 
                        href={url}
                        >
                            {name}
                        </a>
                    </div>;
                }
            })}
        </div>
    );

};

export default BreadCrumbs;
